module.exports = __webpack_public_path__ + "static/media/prev_disabled.47acc4cb.svg";